// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.base-doughnut-chart-box[data-v-9971b43e] {\n  max-height: 320px;\n}\n", ""]);
// Exports
module.exports = exports;
